export default __webpack_public_path__ + "static/media/calendar.f83f0426.svg";